// Shared routing forms path helpers — used by routing redirects and page_source analytics.
// Keep deep-workflow segment markers in sync with the Switch in routing.js.

export const LEGACY_ROUTING_FORMS_BASE = '/app/routing/forms'
const SCHEDULING_ROUTING_FORMS_BASE = '/app/scheduling/routing/forms'

const ROUTING_FORMS_LIST_PATH_PREFIXES = [
  LEGACY_ROUTING_FORMS_BASE,
  SCHEDULING_ROUTING_FORMS_BASE,
]

/** Segments that mark edit, responses, or other non-list flows under …/forms/… */
const ROUTING_FORMS_DEEP_WORKFLOW_SEGMENTS = new Set(['edit', 'responses'])

const getRoutingFormsPrefixMatch = (pathname) => {
  const p = (pathname ?? '').split('?')[0]
  const prefix = ROUTING_FORMS_LIST_PATH_PREFIXES.find((pre) => p === pre || p.startsWith(`${pre}/`))
  if (!prefix) return null

  return { prefix, rest: p.slice(prefix.length).replace(/^\//, '') }
}

/**
 * True when pathname is the routing forms list (scoped index), not wizard or other deep flows.
 */
export const isRoutingFormsListPathname = (pathname) => {
  const match = getRoutingFormsPrefixMatch(pathname)
  if (!match) return false

  const { rest } = match
  if (rest === '') return true

  const segments = rest.split('/').filter(Boolean)
  if (segments.length === 0) return true
  if (segments[0] === 'new') return false
  if (segments.some((segment) => ROUTING_FORMS_DEEP_WORKFLOW_SEGMENTS.has(segment))) return false

  return true
}

/** True for new-form wizard and edit flows (any step) under legacy or scheduling list bases. */
export const isRoutingFormEditorPathname = (pathname) => {
  const match = getRoutingFormsPrefixMatch(pathname)
  if (!match) return false

  const { rest } = match
  if (rest === 'new') return true

  const segments = rest.split('/').filter(Boolean)
  if (segments[0] === 'new') return true

  return segments.includes('edit')
}

/** True for form responses views under legacy or scheduling list bases. */
export const isRoutingFormResponsesPathname = (pathname) => {
  const match = getRoutingFormsPrefixMatch(pathname)
  if (!match) return false

  const segments = match.rest.split('/').filter(Boolean)
  return segments.includes('responses')
}
